export default __webpack_public_path__ + "static/media/school.711c09b2.svg";